<template>
  <div tabindex="0" class="e-card" id="price">
    <div class="e-card-title" style="display: inline-block">{{title}}</div>
    <div>
      <div class="e-card-content">
        <div class="search-container" v-if="!isEditTransaction">
             <div class="search-row">
              <div class="search-control-container">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Invoice Number"
                  v-model="invoiceSearchText"
                />
              </div>
              <div  class="search-button-container">
                <ejs-button
                  type="button"
                  cssClass="e-success"
                  v-on:click.native="populateRefundForm"
                >
                  <font-awesome-icon :icon="['fas', 'search']" />
                </ejs-button>
              </div>
            </div>
        </div>
        <div class="container2" v-if="isValidInvoiceLoaded">
          <div class="leftcol">
            <div class="form-row" style="display: none">
              <div class="form-row-input">Invoice ID: {{ originalInvoice.invoiceId }}</div>
            </div>
             <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Invoice Number:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ originalInvoice.invoiceNumber }}</div>
              </div>
            </div>
            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Invoice Date:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ getDateStringNoTime(originalInvoice.invoiceDate) }}</div>
              </div>
            </div>
            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Invoice Status:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ originalInvoice.invoiceStatus }}</div>
              </div>
            </div>
            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Payment Type:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ originalInvoice.paymentType }}</div>
              </div>
            </div>
            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Original Transaction Number:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ originalInvoice.transactionNumber }}</div>
              </div>
            </div>
            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Original Payment Date:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">
                  {{ getDateStringNoTime(originalInvoice.cancelRefundMetDate) }}</div>
              </div>
            </div>
          </div>
          <div class="middlecol">
            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Reference/PO #:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ originalInvoice.referencePO }}</div>
              </div>
            </div>

            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Applicant Name:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ originalInvoice.applicationRequest.requestor }}</div>
              </div>
            </div>

            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Applicant Company:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ originalInvoice.applicationRequest.company }}</div>
              </div>
            </div>

            <div class="colrow data-flex-row" v-if="enableAppAmount">
              <div class="data-flex-cell">
                <div class="data-label">Application Amount:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ format_currency(originalInvoice.totalAppFee) }}</div>
              </div>
            </div>

            <div class="colrow data-flex-row" v-if="enableLevyAmount">
              <div class="data-flex-cell">
                <div class="data-label">Levy Amount:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ format_currency(originalInvoice.totalLevy) }}</div>
              </div>
            </div>

            <div class="colrow data-flex-row" v-if="enableTankAmount">
              <div class="data-flex-cell">
                <div class="data-label">Tank Amount:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">{{ format_currency(originalInvoice.totalTankFee) }}</div>
              </div>
            </div>

            <div class="colrow data-flex-row">
              <div class="data-flex-cell">
                <div class="data-label">Invoice Amount:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">
                  {{ format_currency(originalInvoice.totalAmount + originalInvoice.totalLevy) }}
                </div>
              </div>
            </div>

            <div class="colrow data-flex-row" v-if="enableTotalPaymentAmount">
              <div class="data-flex-cell">
                <div class="data-label">Total Payment Amount:</div>
              </div>
              <div  class="data-flex-cell">
                <div class="data-value">
                  {{ format_currency(originalInvoice.totalPaymentAmount) }}</div>
              </div>
            </div>
          </div>
        </div>

        <!-- Treeview -->
          <div class="container2 treeview-container"
          v-if="isValidInvoiceLoaded && isRefundTreeviewEnabled">
            <div class="col-treeview">
              <div class="tree-header">Refundable items</div>
              <!-- :nodeChecking='refundNodeChecking' -->
              <ejs-treeview id='treeviewRefund' :fields="fields" :showCheckBox='true'
                :allowMultiSelection='false' :checkedNodes='checkedNodes' :nodeChecked='nodeChecked'
                :nodeTemplate='Template'>
              </ejs-treeview>
              </div>
            <div class="col-treeview shaded-bg"
            v-if="refundHistoryTreeNodes && refundHistoryTreeNodes.length > 0">
              <div class="tree-header">Refund History</div>
              <ejs-treeview id='treeviewHistory' :fields="historyFields"
              :allowMultiSelection='false' :checkedNodes='checkedNodes'  :nodeTemplate='Template'>
              </ejs-treeview>
          </div>
          </div>
          <!-- Treeview end -->

        <div class="container2" v-if="isValidInvoiceLoaded">
          <div class="leftcol">
            <div class="form-row colrow" v-if="enableAppAmount">
              <div style="width: 50%" class="form-row-input">
                <ejs-numerictextbox
                  float-label-type="Always"
                  placeholder="Refund Application Amount"
                  format="C2"
                  :max="maxTotalAppFee"
                  :min="0"
                  :showSpinButton="numericSpin"
                  v-model="newRefundInvoice.totalAppFee"
                  :readonly="isRefundTreeviewEnabled"
                />
              </div>
            </div>

            <div class="form-row colrow" v-if="enableTankAmount || isRefundTreeviewEnabled">
              <div style="width: 50%" class="form-row-input">
                <ejs-numerictextbox
                  float-label-type="Always"
                  placeholder="Refund Tank Amount"
                  format="C2"
                  :max="maxTotalTankFee"
                  :min="0"
                  :showSpinButton="numericSpin"
                  v-model="newRefundInvoice.totalTankFee"
                  :readonly="isRefundTreeviewEnabled"
                />
              </div>
            </div>

            <div class="form-row colrow" v-if="enableLevyAmount">
              <div style="width: 50%" class="form-row-input">
                <ejs-numerictextbox
                  float-label-type="Always"
                  placeholder="Refund Levy Amount"
                  format="C2"
                  :max="maxTotalLevy"
                  :min="0"
                  :showSpinButton="numericSpin"
                  v-model="newRefundInvoice.totalLevy"
                   :readonly="isRefundTreeviewEnabled"
                />
              </div>
            </div>
            <div class="form-row colrow">
              <div style="width: 50%" class="form-row-input">Total Refund Amount:(calculated)</div>
              <div style="width: 50%" class="form-row-input">
                {{ totalRefundAmount }}
              </div>
            </div>

            <div class="form-row colrow">
              <div style="width: 50%" class="form-row-input">
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="newRefundInvoice.transactionNumber"
                  @validate="(v) => (isTransactionValid = v)"
                >
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Refund Transaction"
                  v-model="newRefundInvoice.transactionNumber"
                />
                </scc-input-validator>
              </div>
            </div>

            <div class="form-row colrow">
              <div style="width: 50%" class="form-row-input">
                <scc-input-validator
                  :rules="[requiredRule]"
                  :dateValue="newRefundInvoice.cancelRefundMetDate"
                  @validate="(v) => (isRefundDateValid = v)"
                >
                <ejs-datepicker
                  float-label-type="Always"
                  v-model="newRefundInvoice.cancelRefundMetDate"
                  :placeholder="dateMarker"
                  :format="dateFormat"
                />
                </scc-input-validator>
              </div>
            </div>

            <div class="form-row colrow">
              <div style="width: 50%" class="form-row-input">
                <scc-input-validator
                  :rules="[requiredRule]"
                  :value="newRefundInvoice.cancelRefundReason"
                  @validate="(v) => (isRefundReasonValid = v)"
                >
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Refund Reason:"
                  :multiline="true"
                  rows="5"
                  v-model="newRefundInvoice.cancelRefundReason"
                />
                </scc-input-validator>
              </div>
            </div>

            <div class="form-row colrow">
              <div style="width: 50%" class="form-row-input">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Transaction Update User"
                  v-model="newRefundInvoice.cancelRefundMetBy"
                  :readonly="true"
                />
              </div>
            </div>

            <div class="form-row colrow">
              <div style="width: 50%" class="form-row-input">
                Refund Receipt File: &nbsp;
                <input type="file" @change="uploadFileContent" ref="refundDocument" />
              </div>
            </div>
            <div class="form-row colrow">
              <div style="width: 50%" class="form-row-input">
                <ejs-textbox
                  float-label-type="Always"
                  placeholder="Document Name"
                  v-model="document.invDocument.documentName"
                />
              </div>
            </div>
          </div>
        </div>
        <div class="align-center-bottom">
          <ejs-button
            type="button"
            v-on:click.native="onProcessClick"
            cssClass="e-warning"
            v-if="isValidInvoiceLoaded"
            >Process</ejs-button
          >
          <ejs-button style="margin-left:10px;" v-on:click.native="onCancelClick"
          cssClass="e-success" >Cancel</ejs-button
          >
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { TreeViewPlugin } from "@syncfusion/ej2-vue-navigations";
import { TextBoxPlugin, NumericTextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
import { DropDownListPlugin } from "@syncfusion/ej2-vue-dropdowns";
import { DatePickerPlugin } from "@syncfusion/ej2-vue-calendars";
import { PROCESS_INVOICE_REFUND } from "../store";
import {
  uploadInvoiceDocument,
  getInvoiceDetails, getInvoiceByNumber, getInvoiceById, getRefndInvoiceBySourceId,
} from "../services/accounting-api";
import SccInputValidator from '../../../components/base/scc-input-validator.vue';
// import { Dictionary } from "@syncfusion/ej2-pdf-export";

Vue.use(TextBoxPlugin);
Vue.use(NumericTextBoxPlugin);
Vue.use(DropDownListPlugin);
Vue.use(DatePickerPlugin);
Vue.use(TreeViewPlugin);

export default {
  name: "transactionRefundForm",
  components: {
    SccInputValidator,
  },

  data() {
    // --- Treeview template ---//
    const refundTreeNodeTemplate = Vue.component("refundTreeNode", {
      template: "<div class='node'>"
      + "<div class='node-name'> {{data.name}}</div>"
      + "<div class='node-refund-amount' v-if='data.refundAmount'>"
      + "{{ new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(data.refundAmount) }}"
      + "</div>"
      + "</div>",
      data() {
        return {
          data: {},
        };
      },
    });
    return {
      requestTypesForTreeview: ['STSOP', 'STSOPTEMP', 'STSOPPATCH'],
      refundalbleTreeNodes: [],
      refundHistoryTreeNodes: [],
      checkedNodes: [],
      fields: {
        dataSource: [], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild',
      },
      historyFields: {
        dataSource: [], id: 'id', parentID: 'pid', text: 'name', hasChildren: 'hasChild',
      },
      Template() { // e: argument
        return {
          template: refundTreeNodeTemplate,
        };
      },

      title: "Refund Transaction Form",
      invoiceSearchText: "",
      originalInvoice: null,
      newRefundInvoice: null,
      dateMarker: "Refund Date(yyyy-mm-dd)",
      dateFormat: "yyyy-MM-dd",
      numericSpin: false,
      refundDocumentFile: null,
      document: {
        invoiceId: "",
        invDocument: {
          filesize: 0,
          fileType: "",
          documentContent: "",
          documentName: "",
          documentType: "",
          isActive: true,
        },
      },
      requiredRule: {
        regEx: '^(?!\\s*$).+',
        message: 'This field is required',
      },
      isTransactionValid: false,
      isRefundDateValid: false,
      isRefundReasonValid: false,
    };
  },
  async mounted() {
    await this.populateRefundForm();
  },
  computed: {
    isEditTransaction() {
      return !!this.$route.params.id;
    },
    loggedUser() {
      return this.$store.getters.loggedUser;
    },
    isValidInvoiceLoaded() {
      return !!(this.originalInvoice?.invoiceId);
    },
    enableTotalPaymentAmount() {
      return this.originalInvoice.totalPaymentAmount > 0.01;
    },

    enableAppAmount() {
      return this.originalInvoice.totalAppFee > 0.01;
    },

    totalRefundAmount() {
      return `$${(
        this.newRefundInvoice.totalAppFee
        + this.newRefundInvoice.totalLevy
        + this.newRefundInvoice.totalTankFee
      ).toFixed(2)}`;
    },

    enableLevyAmount() {
      return this.originalInvoice.totalLevy > 0.01;
    },
    maxTotalAppFee() {
      return this.originalInvoice.totalAppFee;
    },
    enableTankAmount() {
      return this.originalInvoice.totalTankFee > 0.01;
    },
    maxTotalLevy() {
      return this.originalInvoice.totalLevy;
    },

    maxTotalTankFee() {
      return this.originalInvoice.totalAmount;
    },
    isRefundTreeviewEnabled() {
      const found = this.requestTypesForTreeview.find(
        (t) => t === this.originalInvoice.applicationRequest.requestType,
      );
      return !!found;
    },
  },

  methods: {
    async populateRefundForm() {
      // console.log(this.loggedUser);
      if (this.isEditTransaction) {
        await this.loadInvoiceForExisitingRefund(this.$route.params.id);
      } else if (this.invoiceSearchText) {
        await this.loadInvoiceForNewRefund();
      }
      if (this.originalInvoice) {
        if (this.isRefundTreeviewEnabled && this.originalInvoice.invoiceId) {
          this.loadInvoiceDetailsAndPopulateTreeviews();
        }
      }
    },
    resetForm() {
      this.refundalbleTreeNodes = [];
      this.refundHistoryTreeNodes = [];
      this.setRefundInvoiceDefault();
      this.setOriginalInvoiceDefault();
    },
    setRefundInvoiceDefault() {
      this.newRefundInvoice = {
        sourceInvoiceId: "",
        applicationRequestRequestId: null,
        transactionNumber: "",
        totalPaymentAmount: 0,
        totalAppFee: 0.0,
        totalLevy: 0.0,
        totalTankFee: 0.0,
        cancelRefundMetDate: null,
        cancelRefundReason: "",
        cancelRefundMetBy: this.loggedUser.name,
        documentId: "",
      };
    },
    setOriginalInvoiceDefault() {
      this.originalInvoice = {
        invoiceId: "",
        invoiceNumber: "",
        invoiceDate: null,
        paymentType: "",
        paymentMethod: "",
        paymentStatus: "",
        cancelRefundMetDate: null,
        totalAmount: 0.0,
        totalAppFee: 0.0,
        totalLevy: 0.0,
        totalTankFee: 0.0,
        totalPaymentAmount: 0.0,
        referencePO: "",
        transactionNumber: "",
      };
    },
    format_currency(val) {
      const formatter = new Intl.NumberFormat("en-US", {
        style: "currency",
        currency: "USD",
      });
      return formatter.format(val);
    },
    async loadInvoiceForExisitingRefund(invoiceId) {
      try {
        this.newRefundInvoice = await getInvoiceById(invoiceId);
        this.originalInvoice = await getInvoiceById(this.newRefundInvoice.sourceInvoiceId);
      } catch (error) {
        console.error(error);
      }
      return this.originalInvoice;
    },
    async loadInvoiceForNewRefund() {
      try {
        // resetting to default before loading
        this.resetForm();
        const tInvoice = await getInvoiceByNumber(this.invoiceSearchText);
        if (!tInvoice || tInvoice.invoiceStatus !== 'Paid') {
          this.notify('Error', 'Search Invoice is not available!');
          return;
        }
        if (tInvoice.sourceInvoiceId) {
          // true: means this is a refund invoice, load the original invoice
          this.newRefundInvoice = tInvoice;
          this.originalInvoice = await getInvoiceById(this.newRefundInvoice.sourceInvoiceId);
        } else {
          // ---check if it is source invoice
          this.originalInvoice = tInvoice;
          const fInvoice = await getRefndInvoiceBySourceId(tInvoice.invoiceId);
          if (fInvoice) {
            this.newRefundInvoice = fInvoice;
          } else {
            this.newRefundInvoice.sourceInvoiceId = this.originalInvoice.invoiceId;
            // eslint-disable-next-line max-len
            this.newRefundInvoice.applicationRequestRequestId = this.originalInvoice.applicationRequest.requestId;
          }
        }
      } catch (error) {
        console.error(error);
      }
      // return this.originalInvoice;
    },
    notify(type, message) {
      this.$parent.notificationToasts.push({
        title: type,
        content: message,
        cssClass: type === 'Error' ? 'e-toast-danger' : 'e-toast-success',
        timeOut: 5000,
      });
      if (this.$parent.notificationToasts.length > 0) {
        this.$parent.$refs.notifierRef.show();
      }
    },
    async onProcessClick() {
      let nofificationMessages = '';
      let isValid = true;
      if (this.isRefundTreeviewEnabled) {
        this.newRefundInvoice.invoiceDetails = [];
        this.refundalbleTreeNodes.forEach((i) => {
          if (!Number.isNaN(i.refundAmount) && i.refundAmount > 0) {
            this.newRefundInvoice.invoiceDetails.push(i);
          }
        });
      }
      let refundId = "";
      try {
        const invoice = this.newRefundInvoice;
        if ((!invoice.totalAppFee && !invoice.totalLevy && !invoice.totalTankFee)
        || invoice.totalAppFee < 0 || invoice.totalLevy < 0 || invoice.totalTankFee < 0) {
          nofificationMessages = 'Refund Amount must > 0;<br>';
          isValid = false;
        }
        if (!invoice.transactionNumber) {
          nofificationMessages += 'Transaction Number is required;<br>';
          isValid = false;
          this.newRefundInvoice.transactionNumber = '';
          this.isTransactionValid = false;
        }
        if (!invoice.cancelRefundMetDate) {
          nofificationMessages += 'Refund Date is required;<br>';
          isValid = false;
          this.newRefundInvoice.cancelRefundMetDate = null;
          this.isRefundDateValid = false;
        }
        if (!invoice.cancelRefundReason) {
          nofificationMessages += 'Refund Reason is required;<br>';
          isValid = false;
          this.newRefundInvoice.cancelRefundReason = '';
          this.isRefundReasonValid = false;
        }
        if (!invoice.documentId && !this.refundDocumentFile) {
          nofificationMessages += 'Document is required;<br>';
          isValid = false;
        }
        if (isValid) {
          await this.$store.dispatch(PROCESS_INVOICE_REFUND, { data: invoice }).then((resp) => {
            refundId = resp.invoiceId;
            this.notify('Success', 'Refund saved successfully.');
          });
        } else {
          this.notify('Error', nofificationMessages);
        }
      } catch (error) {
        this.notify('Error', error.message);
      }
      if (isValid) {
        if (this.refundDocumentFile !== null && refundId !== "") {
          const document = this.document.invDocument;
          const fileName = document.documentName;
          const fileExtension = document.fileType;
          document.documentName = `${fileName}.${fileExtension}`;
          this.document.invoiceId = refundId;
          await uploadInvoiceDocument(this.document)
            .then(() => {})
            .catch((err) => {
              this.notify('Error', err.message);
            });
        }
        this.$router.push("/accounting/manage-accounting");
      }
    },
    onCancelClick() {
      this.$router.push("/accounting/manage-accounting");
    },
    getDateStringNoTime(d) {
      if (d !== null && d !== undefined) {
        const d2 = new Date(d);
        return `${d2.getFullYear()}/${d2.getMonth() + 1}/${d2.getDate()}`;
      }
      return null;
    },
    uploadFileContent() {
      // eslint-disable-next-line prefer-destructuring
      this.refundDocumentFile = this.$refs.refundDocument.files[0];
      // this.document.documentMeta.type = this.refundDocumentFile.type;

      if (this.refundDocumentFile) {
        const document = this.document.invDocument;
        const fileName = this.refundDocumentFile.name;
        const fileInfo = fileName.split(".");
        document.fileType = fileInfo[fileInfo.length - 1]; // extension
        document.fileSize = this.refundDocumentFile.size; // size
        document.documentType = "Refund Receipt";
        document.documentName = fileName.slice(0, fileName.length - (document.fileType.length + 1));
      }

      const fr = new FileReader();

      fr.onload = (e) => {
        const contents = e.target.result;
        if (contents) {
          this.document.invDocument.documentContent = contents.substring(contents.indexOf(",") + 1);
        }
      };

      fr.readAsDataURL(this.refundDocumentFile);
    },

    // vvv--------------[ Treeview ]-------------------vvv //
    async loadInvoiceDetailsAndPopulateTreeviews() {
      try {
        let refundHistoryDetails = [];
        // todo: wrap async calls in a single promise
        const invoiceData = await getInvoiceDetails(this.originalInvoice.invoiceId);
        if (this.newRefundInvoice.invoiceId) {
          // load invoice details from the refund invoice id
          const refundedInvoiceData = await getInvoiceDetails(this.newRefundInvoice.invoiceId);
          if (refundedInvoiceData && refundedInvoiceData.length > 0) {
            refundHistoryDetails = refundedInvoiceData[0].invoiceDetails;
          }
        }
        // ------ Generate Treeview if data is available --------//
        if (invoiceData && invoiceData.length > 0) {
          // 'invoiceData' response should be one invoice obj, but the result is an array
          this.generateTreeview(invoiceData[0].invoiceDetails, refundHistoryDetails);
        } else {
          console.error('no invoice data');
        }
      } catch (error) {
        console.error(error);
      }
    },
    isTankAlreadyRefunded(refundHistoryDetails, tankItem) {
      // todo: verify this condition is correct?
      return refundHistoryDetails.some(
        (r) => r.siteID === tankItem.siteID && r.tankID === tankItem.tankID,
      );
    },

    addTreeviewNodes(nodeList, nodeData) {
      let site = nodeList.find((i) => i.siteID === nodeData.siteID && i.hasChild);
      if (!site) { // -- if site node does not exist adding one --//
        site = {
          id: nodeList.length,
          siteID: nodeData.siteID,
          name: `Site ${nodeData.siteID} - ${nodeData.siteName}`,
          hasChild: true,
        };
        nodeList.push(site);
      }

      const newTankNode = { // -- adding tank nodes --//
        id: nodeList.length,
        pid: site.id,
        name: `Tank# ${nodeData.tankNumber} ${nodeData.tankCompartment ?? ''}
         ${(nodeData.serialNo) ? `Serial# ${nodeData.serialNo}` : ''}`,
        refundAmount: 0,
        ...nodeData,
      };

      nodeList.push(newTankNode);
    },
    // --------- Generate treeview ------------//
    generateTreeview(invoiceDetails, refundHistoryDetails) {
      if (invoiceDetails && invoiceDetails.length > 0) {
        invoiceDetails.forEach((item) => {
          const iDetail = { ...item };

          if (this.isTankAlreadyRefunded(refundHistoryDetails, iDetail)) {
            iDetail.refundAmount = item.regFee + item.sccFee;
            this.addTreeviewNodes(this.refundHistoryTreeNodes, iDetail);
          } else {
            this.addTreeviewNodes(this.refundalbleTreeNodes, iDetail);
          }
        });

        this.fields = { // -- setting the treeview fields --//
          dataSource: this.refundalbleTreeNodes,
          id: 'id',
          parentID: 'pid',
          text: 'name',
          hasChildren: 'hasChild',
        };

        if (this.refundHistoryTreeNodes
        && this.refundHistoryTreeNodes.length > 0) {
          this.historyFields = { // -- setting the refund history treeview fields --//
            dataSource: this.refundHistoryTreeNodes,
            id: 'id',
            parentID: 'pid',
            text: 'name',
            hasChildren: 'hasChild',
          };
        }
      }
    },
    // vvv----------- [ Treeview events ]----------vvv//
    updateTotalTankFee(newTankFee) {
      if (!Number.isNaN(newTankFee)) {
        this.newRefundInvoice.totalTankFee += newTankFee;
      }
    },
    updateTotalLevy(newLevy) {
      if (!Number.isNaN(newLevy)) {
        this.newRefundInvoice.totalLevy += newLevy;
      }
    },
    selectTanksForRefund(tanks) {
      tanks.forEach((t) => {
        if (!t.refundAmount) {
          // eslint-disable-next-line no-param-reassign
          t.refundAmount = t.regFee + t.sccFee;
          this.updateTotalTankFee(t.regFee);
          this.updateTotalLevy(t.sccFee);
        }
      });
    },
    unSelectTanksForRefund(tanks) {
      tanks.forEach((t) => {
        // eslint-disable-next-line no-param-reassign
        t.refundAmount = 0;
        this.updateTotalTankFee(-t.regFee);
        this.updateTotalLevy(-t.sccFee);
      });
    },
    getTanksRelatedToCheckEvent(eventData) {
      let tanks = [];
      if (eventData.length === 1) {
        // parent node checked, while collapse, find and update all child nodes
        const parentNode = eventData.find((i) => i.hasChildren);
        const siteIndex = parseInt(parentNode.id, 10);
        const site = this.refundalbleTreeNodes[siteIndex];
        tanks = this.refundalbleTreeNodes.filter((i) => !i.hasChild && i.siteID === site.siteID);
      } else {
        // ignore the parent nodes and update all the child nodes from the args
        const tankNodes = eventData.filter((i) => !i.hasChildren);
        tankNodes.forEach((n) => {
          const tankIndex = parseInt(n.id, 10);
          tanks.push(this.refundalbleTreeNodes[tankIndex]);
        });
      }
      return tanks;
    },
    nodeChecked(args) {
      const tanks = this.getTanksRelatedToCheckEvent(args.data);
      if (args.action === 'check') {
        this.selectTanksForRefund(tanks);
      } else {
        this.unSelectTanksForRefund(tanks);
      }
      const treeObj = document.getElementById('treeviewRefund').ej2_instances[0];
      treeObj.refresh(); // couldnt find a way to refresh just the node
    },
  },
};

</script>

<style>

@import "../../../assets/styles/eservices-base.css";
.e-card-content {
  margin: 0% !important;
}
.search-container {
  flex-flow: row;
  min-height: 0px;
  text-align: left;
  border: thin solid silver;
  margin: 10px;
  width: 95%;
  padding: 20px inherit;
}
.search-control-container {
    display: inline-block;
    min-width: 200px;
    max-width: 400px;
    width: 70%;
    padding: 10px 20px;
}
.search-button-container {
    display: inline-block;
    margin-left: 10px;
}
.tree-header {
    padding: 10px;
    margin-left: 20px;
}
.col-treeview {
    width: 50%;
    /* background: silver; */
    padding-bottom: 20px;
}
.container2 {
  display: flex;
  flex-flow: row;
  min-height: 0px;
  text-align: left;
  border: thin solid silver;
  margin: 10px;
  width: 95%;
  padding: 20px inherit;
}
.shaded-bg {
  background: #f1f1f1;
}
.data-label {
    color: #303030;
    font-size: 13px;
}
.data-value {
    color: #303030;
    font-size: 13px;
    font-weight: 500;
}

.leftcol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.middlecol {
  margin: 10px;
  display: flex;
  flex-direction: column;
  flex: 4;
  background-color: white;
}

.colrow {
  margin: 4px;
  flex: 1;
}

.data-flex-row {
  display: flex;
  flex-direction: row;
  padding: 0px;
  height: 36px;
}

.data-flex-cell {
  flex: 1;
}

  /* @import "../../node_modules/@syncfusion/ej2-base/styles/material.css";
  @import "../../node_modules/@syncfusion/ej2-vue-navigations/styles/material.css"; */
 .control_wrapper {
        display: block;
        max-width: 350px;
        max-height: 350px;
        margin: auto;
        overflow: auto;
        border: 1px solid #dddddd;
        border-radius: 3px;
    }

    .active{
      color:green;
    }

    .node-name {
    display: inline-block;
    min-width: 200px;
}
.node-refund-amount {
    display: inline-block;
    margin-left: 30px;
    /* background: silver; */
}

</style>
